import VoiceBot from '@qnova-ac/voicebot-web-sdk';
import { getAuthTokens } from '@/api/lib/config';

class VoiceCallService {
  private static instance: VoiceCallService;
  private voiceBotInstance: VoiceBot | null = null;
  private currentToken: string | null = null;

  private constructor() {}

  static getInstance(): VoiceCallService {
    if (!VoiceCallService.instance) {
      VoiceCallService.instance = new VoiceCallService();
    }
    return VoiceCallService.instance;
  }

  async getVoiceBotInstance(): Promise<VoiceBot> {
    const tokens = getAuthTokens();
    const jwtToken = tokens?.access_token;

    if (!jwtToken) {
      throw new Error('No authentication token available');
    }

    // Only create a new instance if the token changes or no instance exists
    if (!this.voiceBotInstance || this.currentToken !== jwtToken) {
      // Clean up old instance if it exists
      if (this.voiceBotInstance) {
        this.voiceBotInstance.stop();
        this.voiceBotInstance = null;
      }
      
      // Create new instance with JWT token
      this.currentToken = jwtToken;
      this.voiceBotInstance = new VoiceBot(jwtToken);
    }
    
    return this.voiceBotInstance;
  }

  cleanup(): void {
    if (this.voiceBotInstance) {
      this.voiceBotInstance.stop();
    }
  }
}

export default VoiceCallService.getInstance(); 